import React, { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button, Format, Panel, Text } from 'src/Components'

import styles from '../EditBalance.module.scss'

const EditBalanceInterstital = ({
  onCancel,
  estimatedValue,
  hideInterstitial
}) => (
  <Fragment>
    <Panel.Heading>
      <FormattedMessage
        id='Mortgages.editBalance.interstitialHeading'
        defaultMessage='Made extra payments?'
      />
    </Panel.Heading>

    <div className={styles.text}>
      <Text size='l' weight='light' align='center'>
        <FormattedMessage
          id='Mortgages.editBalance.interstitialSubheading'
          defaultMessage='We’ve estimated your balance is {balance}'
          values={{
            balance: <Format.Currency value={estimatedValue} format='0,0' />
          }}
        />
      </Text>
    </div>

    <div className={styles.text}>
      <Text color='quiet' size='s' align='center'>
        <FormattedMessage
          id='Mortgages.editBalance.interstitialExplainer'
          defaultMessage="If you've made extra principal payments or have had your balance adjusted, it's good to true-up your balance here. Otherwise, you can stay on auto-pilot and we'll keep you up to date each month!"
        />
      </Text>
    </div>

    <Button.Group className={styles.buttonGroup}>
      <Button
        onClick={hideInterstitial}
        data-qa='EditBalanceInterstitialNextButton'
      >
        <FormattedMessage
          id='Mortgages.editBalance.interstitialChangeButton'
          defaultMessage='Yes, change'
        />
      </Button>
      <Button onClick={onCancel} data-qa='EditBalanceInterstitialCancelButton'>
        <FormattedMessage
          id='Mortgages.editBalance.interstitialSkipButton'
          defaultMessage='Skip for now'
        />
      </Button>
    </Button.Group>
  </Fragment>
)

export default EditBalanceInterstital
